import LocalStorageSupport from '../web/LocalStorageSupport';

export default function() {
	const ls = new LocalStorageSupport();
	if (ls.getItem('KM_GA_DIMENSION_USERID')) {
		/*dataLayer.push({
			"userId": parseInt(ls.getItem('KM_GA_DIMENSION_USERID'))
		});*/
	}
};



// WEBPACK FOOTER //
// ./fe/web-default/src/js/gtm-event/dimension-user.js